
import chatr from './img/chatr.png'
import lucky from './img/lucky.png'
import digicel from './img/Digicel.png'
import flow from './img/Flow.jpeg'
import { useEffect } from 'react';
import { NavLink, createSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

function Topup() {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return (
        <div>
       <div style={{display:'flex', flexDirection:'row', width:'100%', position:"absolute"}}><NavLink to="/"><FontAwesomeIcon style={{position:"absolute", marginLeft:10, marginTop:25, color:'#663399'}}icon={faArrowLeft} className="fa-2xl"/></NavLink><div style={{width:'100%'}}><h1 style={{justifySelf:"center"}}>Please choose a plan</h1></div></div>
    
   <div style={{display:'flex', flexWrap:'wrap',justifyContent:'space-evenly', alignItems:'center', width:'100%', height:'90vh'}}>
     <NavLink to={{pathname:'/formtopup', search: createSearchParams({carrier:'Chatr'}).toString()}}><img src={chatr} height='250' style={{borderRadius:40}}/></NavLink>
          <NavLink to={{pathname:'/formtopup', search: createSearchParams({carrier:'Lucky'}).toString()}}><img src={lucky} height='250' /></NavLink>
          <NavLink to={{pathname:'/formtopup', search: createSearchParams({carrier:'Flow'}).toString()}}><img src={flow} height='250' style={{borderRadius:40}}/></NavLink>
     <NavLink to={{pathname:'/formtopup', search: createSearchParams({carrier:'Digicel'}).toString()}}><img src={digicel} height='250' style={{borderRadius:40}}/></NavLink>
     </div></div>
 );
}

export default Topup;
